import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type Role = { id: string; name: string; description: string; permission_codes: string[]; is_system: boolean; template_key: string; member_count: number; updated_at: string };
export type CatalogGroup = { spoke: string; title: string; features: { feature: string; permissions: { code: string; action: string; label: string }[] }[] };

export function useRoles() {
  return useQuery({ queryKey: ["roles"], queryFn: async () => { const { data, error } = await api.GET("/api/v1/accounts/roles/", { params: { query: { page_size: 200 } } }); if (error) throw new Error(errorMessage(error)); return (data as unknown as { results: Role[] }).results; } });
}

export function useCatalog() {
  return useQuery({ queryKey: ["permission-catalog"], staleTime: Infinity, queryFn: async () => { const { data, error } = await api.GET("/api/v1/accounts/permissions/"); if (error) throw new Error(errorMessage(error)); return data as unknown as CatalogGroup[]; } });
}

export function useSaveRole() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...body }: Partial<Role> & { id?: string }) => {
      const { data, error } = id
        ? await api.PATCH("/api/v1/accounts/roles/{id}/", { params: { path: { id } }, body: body as never })
        : await api.POST("/api/v1/accounts/roles/", { body: body as never });
      if (error) throw error;
      return data as unknown as Role;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["roles"] }),
  });
}

export function useRoleAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, action, name }: { id: string; action: "duplicate" | "delete"; name?: string }) => {
      const { error } = action === "duplicate"
        ? await api.POST("/api/v1/accounts/roles/{id}/duplicate/", { params: { path: { id } }, body: { name } as never })
        : await api.DELETE("/api/v1/accounts/roles/{id}/", { params: { path: { id } } });
      if (error) throw new Error(errorMessage(error));
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["roles"] }),
  });
}
